import React from "react"
import AttributionCookie from "src/utils/AttributionCookie"

const LifatidCookie = () => <AttributionCookie name="li_fat_id" />

export default LifatidCookie
